import * as yup from 'yup';

export const searchFormValidation = () => {
  return yup.object().shape({
    search: yup.string().required('Search field must not be empty'),
  });
};
